// extracted by mini-css-extract-plugin
export default {"header":"B0heaZ","header__title":"KxK9Wd","header__subtitle":"NRRp7H","header__close":"NtoWFd"};